import { z } from "zod";

import { OverduePaymentFormValues } from "./types";

export const INITIAL_VALUES_OVERDUE_PAYMENT_FORM: OverduePaymentFormValues = {
  paymentMethodId: undefined,
};

export const overduePaymentFormSchema = z.object({
  paymentMethodId: z
    .string({ required_error: "Add payment method" })
    .optional(),
});
